module.exports = __webpack_public_path__ + "media/images/illustrations/babysitter-e0206dac15ec96c7df812caf90f85ca4.svg";